// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"2593f6d6a967335a","3869":"56daef4ba15f4745"}[chunkId] + ".css";
};